import { Link } from "react-router-dom";
import AppSwitcher from "../components/AppSwitcher";
import "./Bokiori.css";

function Bokiori() {
  return (
    <div className="bokiori">
      <header className="bokiori-header">
        <div className="header-inner">
          <Link to="/bokiori" className="logo-link">
            <img
              src="/bokiori-assets/app-icon.png"
              alt="복이오리 앱 아이콘"
              className="header-logo"
            />
            <span className="header-title">복이오리 - 매일의 미션</span>
          </Link>
          <div className="header-sns">
            <AppSwitcher />
          </div>
        </div>
      </header>

      <main className="bokiori-main">
        <section className="hero">
          <div className="hero-content">
            <img
              src="/bokiori-assets/hero-banner.jpg"
              alt="복이오리 - 매일의 미션, 행운의 보상!"
              className="hero-banner"
            />
            <p className="hero-tagline">
              매일 출석하고 미션을 깨면서 오리알을 모아보세요 🍀
            </p>
            <div className="hero-buttons">
              <span className="store-btn store-btn-soon">App Store 출시 예정</span>
              <span className="store-btn store-btn-soon">Google Play 출시 예정</span>
            </div>
          </div>
        </section>

        <section className="preview">
          <h2 className="section-title">앱 미리보기</h2>
          <div className="preview-grid">
            <img src="/bokiori-assets/preview-1.jpg" alt="복이오리 홈 화면과 일일 퀘스트 미리보기" />
            <img src="/bokiori-assets/preview-2.jpg" alt="복이오리 골드에그와 클로버 포인트 미리보기" />
          </div>
        </section>

        <section className="features">
          <h2 className="section-title">다양한 즐길거리</h2>
          <p className="section-subtitle">매일 새로운 미션과 보상이 기다려요</p>
          <div className="features-grid">
            <figure className="feature-card">
              <img src="/bokiori-assets/feature-fortune.jpg" alt="매일 만나는 운세 - 오늘의 운세를 확인하세요" />
            </figure>
            <figure className="feature-card">
              <img src="/bokiori-assets/feature-invite.jpg" alt="친구 초대하고 혜택 받기 - 오리알 최대 30% 지급" />
            </figure>
            <figure className="feature-card">
              <img src="/bokiori-assets/feature-gifticon.jpg" alt="다양한 기프티콘 교환" />
            </figure>
            <figure className="feature-card">
              <img src="/bokiori-assets/feature-attendance.jpg" alt="매일 출석하고 보상 받기" />
            </figure>
          </div>
        </section>

        <section className="event">
          <div className="event-inner">
            <img src="/bokiori-assets/event-giveaway.jpg" alt="상품 응모 가이드 - 아이패드 프로, 금, 네이버페이" className="event-image" />
            <div className="event-copy">
              <p className="event-subtitle">모으고, 응모하고</p>
              <h2 className="event-title">푸짐한 경품에 도전하세요</h2>
              <p className="event-desc">
                아이패드 프로, 순금, 네이버페이 포인트까지<br />
                다양한 상품에 응모할 수 있어요.
              </p>
            </div>
          </div>
        </section>

        <section className="cta">
          <div className="cta-inner">
            <img src="/bokiori-assets/duck-gift.jpg" alt="복이오리 캐릭터" className="cta-duck" />
            <div className="cta-content">
              <p className="cta-subtitle">지금 준비 중이에요</p>
              <h2 className="cta-title">복이오리와 함께<br />행운을 잡아보세요</h2>
              <div className="cta-buttons">
                <span className="store-btn store-btn-soon">App Store 출시 예정</span>
                <span className="store-btn store-btn-soon">Google Play 출시 예정</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bokiori-footer">
        <div className="footer-inner">
          <img src="/bokiori-assets/app-icon.png" alt="복이오리" className="footer-logo" />
          <p className="footer-company">주식회사 셀링</p>
          <p className="footer-address">
            화성시 동탄대로21길 10 1512-에이18호(더피스트타워)<br />
            215-88-01706 | 대표 이지훈
          </p>
          <p className="footer-tel">031-221-9719</p>
        </div>
        <p className="footer-copy">© 2024 주식회사 셀링. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Bokiori;
